﻿import React from 'react';

import { Checkbox } from "@blueprintjs/core";

import classNames from 'classnames';
import 'components/form-fields/FormFields.css';

export function FormCheckbox(props) {
    const checkboxHtml = <Checkbox checked={props.checked} label={props.label} disabled={props.loading || props.disabled} id={props.id} identifier={props.id} onChange={onChange} className={classNames({ "checkbox-disable-styled": props.disableStyled, "bp6-skeleton": props.loading })} />

    function onChange(event) {        
        props.onChange(event, props.identifier);
    }
    if (props.headingText) {
        return (        
            <div className="form-field">
                <h4 className={classNames({ "bp6-skeleton": props.loading })}>{props.headingText}</h4>
                {checkboxHtml}
            </div>
        );
    }

    return checkboxHtml;   
    
}